import type {
  FetchCartRequest,
  FetchCartResponse as CoreFetchCartResponse,
  UpdateCartQuantityRequest,
  UpdateCartRequest,
} from '../../../node_modules/@eliadmin/core/src/api/cart/cart-api';
import { buildAuthHeader, fetchData } from '@eliadmin/core/src/api/fetcher';
import type { ProductAccessoryProduct } from '@eliadmin/core/src/api/products/types/product-types';

export * from '../../../node_modules/@eliadmin/core/src/api/cart/cart-api';

export type CartAccessoryType = 'accessory' | 'required_accessory' | 'product_variant';

export type CartAccessoryProduct = ProductAccessoryProduct & {
  accessory_product?: {
    id: number;
    type?: CartAccessoryType | null;
  };
};

export type FetchCartResponse = Omit<CoreFetchCartResponse, 'data'> & {
  data: Omit<CoreFetchCartResponse['data'], 'accessories'> & {
    accessories?: CartAccessoryProduct[];
    required_accessories?: CartAccessoryProduct[];
  };
};

/**
 * RS Moto needs the accessory recommendations with every full cart read.
 * The backend deliberately omits both accessory groups when this numeric flag is absent.
 */
export function fetchCart(req: FetchCartRequest) {
  return fetchData<FetchCartResponse>({
    uri: '/store/cart',
    query: {
      items: true,
      coupons: true,
      paymentType: true,
      shipment: true,
      accessories: 1,
    },
    method: 'GET',
    cache: 'no-store',
    next: { revalidate: undefined },
    headers: buildAuthHeader(req.authToken),
    ...req,
  });
}

/** Keep accessory recommendations in the response used for the cart cache. */
export function updateCartQuantity(req: UpdateCartQuantityRequest) {
  return fetchData<FetchCartResponse>({
    uri: '/store/cart/quantity',
    query: {
      items: true,
      coupons: true,
      paymentType: true,
      shipment: true,
      accessories: 1,
    },
    method: 'PUT',
    headers: buildAuthHeader(req.authToken),
    ...req,
  });
}

/** Gift/service updates are full cart snapshots, including RS Moto recommendations. */
export function updateCart(req: UpdateCartRequest) {
  return fetchData<FetchCartResponse>({
    ...req,
    uri: '/store/cart',
    method: 'PUT',
    cache: 'no-store',
    query: { items: true, coupons: true, paymentType: true, shipment: true, accessories: 1 },
    headers: buildAuthHeader(req.authToken),
  });
}
